import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { first, map } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { CurrencyWalletService } from 'src/app/layouts/currency-wallet/currency-wallet.service';
import { UserAssetsService } from 'src/app/pages/user-asset/user-assets.service';
import { CurrenciesInterface } from 'src/app/shared/interfaces/deposit.interface';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';
import { PaymentIqService } from '../../../shared/components/select-deposit-bonus/payment-iq/payment-iq.service';
import { WalletEvent, WalletService } from '../wallet.service';
import { IncomingData } from './../../../shared/interfaces/select-currency.interface';
interface CurrencyDisplay {
  [uid: string]: string[];
}
/**
 * 选择法币弹窗
 */
@UntilDestroy()
@Component({
  selector: 'app-wallet-select-currency',
  templateUrl: './wallet-select-currency.component.html',
  styleUrls: ['./wallet-select-currency.component.scss'],
})
export class WalletSelectCurrencyComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<WalletSelectCurrencyComponent>,
    public appService: AppService,
    private userAssetsService: UserAssetsService,
    private localeService: LocaleService,
    private localStorageService: LocalStorageService,
    private walletService: WalletService,
    private cdr: ChangeDetectorRef,
    public currencyWalletService: CurrencyWalletService,
    private piqService: PaymentIqService,
  ) {}

  data: IncomingData = {
    showBalance: true,
    isDigital: false,
  };

  /** 是否展示 返回icon 默认显示 */
  @Input() isShowBackIcon: boolean = true;

  @Output() currencyItem = new EventEmitter();
  /** 所有币种 */
  currencies: CurrenciesInterface[] = [];
  /** 选择的币种 有分fiat crypto display=true才显示*/
  selectCurrencies: CurrenciesInterface[] = [];
  /** 编辑币种 */
  editCurrencies: CurrenciesInterface[] = [];
  /** 搜索关键字 */
  keyword: string = '';
  /** 是否加载中 */
  isLoading: boolean = true;
  /** 余额加载中 */
  isBalanceLoading: boolean = true;
  /** seletOpen=true 选择币种 seletOpen=false 编辑币种  */
  seletOpen = true;
  /** 编辑币种选单 */
  menu = [
    {
      title: this.localeService.getValue('fiat'),
    },
    {
      title: this.localeService.getValue('crypto'),
    },
  ];
  selectIndex = 0;
  /** userUid 默认为-1， 用于用户未登录的时候判断*/
  userUid: string = '-1';
  currentCurrencyData!: CurrenciesInterface;
  /** 从哪里开启选择货币 walletcomponet要判断后再把值传道各个compoent内 */
  from: string = '';
  isSortAZ: boolean = true;
  hideLed: boolean = false;
  ngOnInit() {
    this.userUid = this.appService.userInfo$.getValue()?.uid as string;
    this.currentCurrencyData = this.appService.currentCountry$.getValue();
    this.appService.openWalletSelectCurrency$.pipe(untilDestroyed(this)).subscribe(data => {
      this.isLoading = true;
      this.isBalanceLoading = true;
      this.selectCurrencies = [];
      this.editCurrencies = [];
      this.data = data;
      this.from = this.data.from!;

      this.data.isShowAllCurrencies = data.isShowAllCurrencies;
      if (this.data.useData) {
        // 使用传入的数据渲染
        this.isLoading = false;
        this.isBalanceLoading = false;
      } else {
        // 自动获取数据
        this.appService.currencies$
          .pipe(
            first(x => x.length > 0),
            map(v =>
              v.filter(x => {
                if (data.hideLed) {
                  return x.currency != 'LED' && x.isVisible;
                } else {
                  return x.isVisible;
                }
              }),
            ),
            untilDestroyed(this),
          )
          .subscribe(async currencies => {
            this.currencies = currencies;
            this.initData();
            this.isLoading = false;
            if (this.data.showBalance) {
              this.currencies.forEach(x => (x.balance = x.rate = x.exchangedAmount = 0));
              const allRates: any = this.userAssetsService.allRate.value;
              this.userAssetsService
                .getUserbalance()
                .pipe(untilDestroyed(this))
                .subscribe(allUesrBalance => {
                  this.currencies.forEach(x => {
                    const userCurrency = allUesrBalance.find((y: any) => y.currency == x.currency);
                    if (userCurrency) {
                      x.balance = userCurrency.balance;
                      x.rate = allRates.rates?.find((i: any) => i.currency == x.currency)?.rate ?? 0;
                      x.exchangedAmount = Number(userCurrency.balance).subtract(x.rate);
                    }
                  });
                  this.isBalanceLoading = false;
                });
            }
          });
      }
    });
  }

  /**
   * 初始化
   *
   * @returns
   */
  initData() {
    if (!this.currencies) return;
    const currencyDisplay = this.localStorageService.currencyDisplay;
    this.editCurrencies = this.currencies;
    this.currencies.forEach(x => {
      if (currencyDisplay) {
        const userHasLogined = Object.keys(currencyDisplay).filter(uid => this.userUid == uid).length > 0;
        if (userHasLogined) {
          //本地有数据，使用本地数据
          x.display = currencyDisplay[this.userUid].includes(x.currency);
        } else {
          x.display = true;
        }
      } else {
        //本地没数据，默认全部显示
        x.display = true;
      }
      // 恒定当前选中的为true，防止一些边界情况
      if (x.currency === this.currentCurrencyData?.currency) x.display = true;
      if (this.data.isShowAllCurrencies) {
        this.selectCurrencies = this.currencies.filter(x => x.display);
      } else {
        this.selectCurrencies = this.currencies.filter(x => x.isDigital == this.data.isDigital && x.display);
      }
    });
  }

  /**
   * 选择币种
   *
   * @param item 币种
   */
  handleSelect(item: any) {
    const event: WalletEvent<CurrenciesInterface> = {
      from: this.from,
      data: item,
    };

    this.walletService.selectCurrencyEvent$.next({
      from: this.from,
      data: item,
    });

    console.log('选择币种', event);

    // 纯粹选择，跳过无关逻辑
    if (!this.data.purely) {
      // piq 中判断 不包含 虚拟货币
      if (!item.isDigital) {
        if (this.piqService.limitPiqCurrencies?.find(currency => currency === event.data?.currency)) {
          this.piqService.isPidOpened = false;
        } else {
          this.piqService.isPidOpened = true;
        }
      }
      this.appService.selectCurrencyData = item;
    }
    this.appService.openWalletSelectCurrency$.next({
      isOpen: false,
      from: this.from,
      isSelected: true,
    });
  }

  /**
   * 关闭弹窗
   */
  close(): void {
    this.appService.closeDialogInTransition(this.dialogRef);
    // this.dialogRef.close();
  }

  /** 回到选择货币 */
  back() {
    this.appService.openWalletSelectCurrency$.next({ isOpen: false, isSelected: false });

    // this.appService.selectCurrencyData 不为undefined 的时候; 并且不为虚拟货币时
    if (this.appService.selectCurrencyData && !this.appService.selectCurrencyData?.isDigital) {
      if (
        this.piqService.limitPiqCurrencies?.find(currency => currency === this.appService.selectCurrencyData?.currency)
      ) {
        this.piqService.isPidOpened = false;
      } else {
        this.piqService.isPidOpened = true;
      }
    }
  }

  /**
   * 選擇類型 0:fiat 1:crypto
   *
   * @param index
   * @returns
   */
  selectMenu(index: number) {
    if (this.selectIndex == index) {
      return;
    }
    this.selectIndex = index;
  }

  /**
   * 儲存幣種顯示
   */
  saveCurrencyDisplay() {
    const selectedArr: string[] = [];

    this.editCurrencies.forEach(x => {
      if (x.display) selectedArr.push(x.currency);
    });

    const currencyDisplay: CurrencyDisplay = this.localStorageService.currencyDisplay || {};

    this.localStorageService.currencyDisplay = {
      ...currencyDisplay,
      [this.userUid]: selectedArr,
    };

    this.initData();
  }
}
